import { type CSSProperties } from 'react';

// Table cell styles
export const stickyColumnHeadStyle = {
  position: 'sticky', 
  left: 0, 
  backgroundColor: '#fff', 
  zIndex: 11, 
  fontWeight: 'bold',
  fontSize: '11px',
  padding: '4px',
  width: '45px',
  minWidth: '45px',
  maxWidth: '45px',
  lineHeight: '1.2',
  margin: 0,
  '&.MuiTableCell-head': {
    backgroundColor: '#fff !important',
    margin: 0
  }
} as const;

export const stickyColumnBodyStyle = {
  position: 'sticky', 
  left: 0, 
  backgroundColor: '#fff', 
  zIndex: 1,
  fontSize: '11px',
  padding: '4px',
  width: '45px',
  minWidth: '45px',
  maxWidth: '45px',
  margin: 0,
  '&.MuiTableCell-body': {
    backgroundColor: '#fff',
    margin: 0
  }
} as const;

export const baseColumnHeadStyle = {
  backgroundColor: '#fff',
  fontWeight: 'bold',
  fontSize: '11px',
  padding: '4px',
  width: '45px',
  minWidth: '45px',
  maxWidth: '45px',
  lineHeight: '1.2',
  '&.MuiTableCell-head': {
    backgroundColor: '#fff !important'
  }
} as const;

export const baseColumnBodyStyle = {
  backgroundColor: '#fff',
  fontSize: '11px',
  padding: '4px',
  width: '45px',
  minWidth: '45px',
  maxWidth: '45px',
  '&.MuiTableCell-body': {
    backgroundColor: '#fff'
  }
} as const;

export const stationNameHeadStyle = {
  fontWeight: 'bold',
  fontSize: '11px',
  padding: '4px',
  width: '100px',
  minWidth: '100px',
  maxWidth: '100px',
  lineHeight: '1.2'
} as const;

export const stationNameBodyStyle = {
  fontSize: '11px',
  padding: '4px',
  width: '100px',
  minWidth: '100px',
  maxWidth: '100px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
} as const;

export const timeColumnHeadStyle = {
  position: 'sticky',
  top: 0,
  width: '44px',
  minWidth: '44px',
  maxWidth: '44px',
  padding: '12px 4px 4px 4px',
  fontSize: '11px',
  textAlign: 'center',
  lineHeight: '1.2',
  zIndex: 10,
  '& .MuiTableSortLabel-root': {
    justifyContent: 'center',
    width: '100%'
  }
} as const;

export const timeColumnBodyStyle = {
  width: '44px',
  minWidth: '44px',
  maxWidth: '44px',
  padding: '4px',
  fontSize: '11px',
  textAlign: 'center'
} as const;

export const sensorHeaderStyle = {
  margin: '0 0 8px 0',
  fontSize: '14px',
  fontWeight: 'bold',
  position: 'sticky',
  left: 0,
  top: 0,
  backgroundColor: '#fff',
  width: 'auto',
  minWidth: '70px',
  maxWidth: '300px',
  zIndex: 11,
  padding: '4px 0',
  textAlign: 'left',
  overflow: 'visible'
  //transform: 'translateZ(0)'
} as const;

// Base styles for cells and headers
export const baseCellStyle: CSSProperties = {
  width: '100%',
  textAlign: 'center'
};

export const baseHeaderStyle = {
  fontSize: '9px',
  lineHeight: '1',
  marginBottom: '2px',
  color: '#666666'
};

export const hiddenHeaderStyle = {
  fontSize: '9px',
  lineHeight: '1',
  marginBottom: '2px',
  visibility: 'hidden' as const
};

export const stickyColumnsContainerStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 10,
  width: '145px', // Width of sticky columns
  pointerEvents: 'none' // Allow clicks to pass through to main table
} as const;

export const stickyColumnsInnerStyle = {
  pointerEvents: 'auto' // Re-enable pointer events for sticky column tables
} as const;
